import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState }, { payload, financialAccountId }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const response = await fetch(
    `${URI_FINANCIAL_ACCOUNT}financial-accounts/${financialAccountId}`,
    opts,
  );

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult.data;
};
